// src/views/EjecucionesManuales/RenovacionDeTarjetas/RenovacionDeTarjetas.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function RenovacionDeTarjetas({ onRedirect }) {
  return (
    <EjecutarProceso
      procesoId={5}
      titulo="Renovación de Tarjetas"
      redirectView="listaTarjetas"   // ⬅️ EXACTO
      onRedirect={onRedirect}
    />
  );
}
